var render = function (_h,_vm) {var _c=_vm._c;return _c('v-icon',_vm._g(_vm._b({class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"color":"error","small":""}},'v-icon',_vm.data.attrs,false),_vm.listeners),[_vm._v("\n  mdi mdi-alert\n")])}
var staticRenderFns = []

export { render, staticRenderFns }